import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, name, type, keywords }) => {
  const siteTitle = title ? `${title} | PAOZ Hope Community Church (HCC)` : 'PAOZ Hope Community Church (HCC)';
  const metaDescription = description || 'Welcome to PAOZ Hope Community Church (HCC) in Westgate, Harare. A vibrant Pentecostal Assemblies of Zimbabwe community of faith, hope, and love.';
  const metaKeywords = keywords || 'PAOZ, HCC, Hope Community Church, Pentecostal Assemblies of Zimbabwe, Westgate Church, Harare Church, PAOZ HCC';

  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{siteTitle}</title>
      <meta name='description' content={metaDescription} />
      <meta name='keywords' content={metaKeywords} />
      
      {/* End standard metadata tags */}
      {/* Facebook tags */}
      <meta property="og:type" content={type || "website"} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={metaDescription} />
      {/* End Facebook tags */}
      
      {/* Twitter tags */}
      <meta name="twitter:creator" content={name || "PAOZ HCC"} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={metaDescription} />
      {/* End Twitter tags */}
    </Helmet>
  );
};

export default SEO;
